angular.module('ecrd')
    .service('EntityNotesVisibilityService', ['$rootScope', function($rootScope){
        var notesVisibility = {};

        return {
            setFieldNotesVisibility: function(fieldName, visible){
                notesVisibility[fieldName] = !!visible;

                // Emit event if notes are now visible
                if (notesVisibility[fieldName]){
                    $rootScope.$broadcast('entityFieldNotesShown', fieldName);
                } else {
                    $rootScope.$broadcast('entityFieldNotesHidden', fieldName);
                }
            },
            areNotesVisible: function(fieldName){
                return typeof notesVisibility[fieldName] !== 'undefined' && notesVisibility[fieldName];
            },
            getNotesVisibility: function() {
                return notesVisibility;
            }
        }
    }]);
